import React, { useRef } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import SaveButton from "../UI/SaveButton";
import useExportChartImage from "../useExportChartImage";
import { getCategoryLabelById } from "../../../utils/labelsById";

// Regjistrimi i moduleve
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels
);

const HorizontalBar2Value = ({ data, dataSetting, title }) => {
  const chartRef = useRef();
  const exportChartImage = useExportChartImage();

  const fileName = dataSetting?.name + "_" + dataSetting?.year;

  const pozicione = data["Pozicioni i punës"];
  const pagaJanar = data["Paga - Janar"];
  const pagaKorrik = data["Paga - Korrik"];

  const totalPozicione = Object.values(pozicione).reduce((a, b) => a + b, 0);
  const totalJanar = Object.values(pagaJanar).reduce((a, b) => a + b, 0);
  const totalKorrik = Object.values(pagaKorrik).reduce((a, b) => a + b, 0);

  const labels = Object.keys(pozicione);

  const generateChartData = (paga, totalPaga, monthLabel) => {
    const staffPercent = labels.map((label) =>
      Math.round(((pozicione[label] || 0) / totalPozicione) * 100)
    );
    const pagaPercent = labels.map((label) =>
      Math.round(((paga[label] || 0) / totalPaga) * 100)
    );

    return {
      labels,
      datasets: [
        {
          label: "% e stafit sipas profesionit",
          data: staffPercent,
          backgroundColor: "#cc0000", // e kuqe
          stack: "total",
        },
        {
          label: `% sipas totalit të pagave ${monthLabel}`,
          data: pagaPercent,
          backgroundColor: "#ffcccc", // rozë
          stack: "total",
        },
      ],
    };
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      datalabels: {
        color: "#333", // ngjyra më e errët e përqindjeve
        anchor: "center",
        align: "center",
        formatter: (value) => `${value}%`,
        font: {
          weight: "bold",
          size: 12,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}%`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          callback: (value) => `${value}%`,
          beginAtZero: true,
          max: 100,
        },
      },
      y: {
        stacked: true,
      },
    },
  };

  // --- Export Button Handler ---
  const handleExportImage = () => {
    exportChartImage({
      chartRef,
      fileName,
      dataSetting,
    });
  };

  return (
    <div>
      {title && (
        <h3 style={{ marginBottom: "20px" }}>{getCategoryLabelById(title)}</h3>
      )}
      <div style={{ width: "100%" }} ref={chartRef}>
        {/* <h3 style={{ marginBottom: 10 }}>Janar</h3> */}
        <Bar
          data={generateChartData(pagaJanar, totalJanar, "janar")}
          options={options}
        />
        <div style={{ height: "30px" }} />

        {/* <h3 style={{ marginTop: 40, marginBottom: 10 }}>Korrik</h3> */}
        <Bar
          data={generateChartData(pagaKorrik, totalKorrik, "korrik")}
          options={options}
        />
      </div>
      <SaveButton onClick={handleExportImage} />
    </div>
  );
};

export default HorizontalBar2Value;
